import { render, staticRenderFns } from "./KBKLimitsEditableList.view.vue?vue&type=template&id=044ac726&"
import script from "./KBKLimitsEditableList.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitsEditableList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044ac726')) {
      api.createRecord('044ac726', component.options)
    } else {
      api.reload('044ac726', component.options)
    }
    module.hot.accept("./KBKLimitsEditableList.view.vue?vue&type=template&id=044ac726&", function () {
      api.rerender('044ac726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/kbk-limits/update/KBKLimitsEditableList.view.vue"
export default component.exports